import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import withQuerySync from '@/hocs/withQuerySync';

import queryDuck from '../ducks/query';
import {
  getParkingWhitelistError,
  getParkingWhitelistIds,
  getParkingWhitelistTotalCount,
  isLoadingParkingWhitelist,
} from '../selectors';
import ParkingWhitelist from './component';
import styles from './styles';

const mapStateToProps = state => ({
  error: getParkingWhitelistError(state),
  parkingWhitelistIds: getParkingWhitelistIds(state),
  isLoading: isLoadingParkingWhitelist(state),
  totalCount: getParkingWhitelistTotalCount(state),
});

export default compose(
  withQuerySync(queryDuck),
  connect(mapStateToProps),
  withStyles(styles),
)(ParkingWhitelist);
